// @ts-nocheck -- see CLAUDE.md's "TypeScript checking on assets/*.js" section for why
(function () {
  window.OXTAK_I18N = window.OXTAK_I18N || {};
  var OXH_I18N = window.OXH_I18N;
  Object.keys(OXH_I18N).forEach(function (code) {
    window.OXTAK_I18N[code] = window.OXTAK_I18N[code] || {};
    window.OXTAK_I18N[code].features = OXH_I18N[code];
  });
  document.querySelectorAll(".oxh-uc-tab").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (btn.classList.contains("active")) return;
      var id = btn.getAttribute("data-tab");
      var current = document.querySelector(".oxh-uc-panel.active");
      document.querySelectorAll(".oxh-uc-tab").forEach(function (b) {
        b.classList.remove("active");
      });
      btn.classList.add("active");
      if (current) {
        current.classList.add("fading");
      }
      setTimeout(function () {
        document.querySelectorAll(".oxh-uc-panel").forEach(function (p) {
          p.classList.remove("active");
          p.classList.remove("fading");
        });
        document.getElementById(id).classList.add("active");
      }, 400);
    });
  });
  document.querySelectorAll(".oxh-faq-trigger").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var open = btn.parentElement.classList.toggle("open");
      var icon = btn.querySelector("span:last-child");
      if (icon) {
        icon.textContent = open ? "−" : "+";
      }
    });
  });
  window.applyLocale(window.getOxtakLocale());
})();
